module.exports = __webpack_public_path__ + "media/images/misc/custom-form-sprites-cf9237ae6ddfdb7cf8982529b4a77ca6cef85bad2d7566fed0bbade766ebd831.png";